import SignupComponent from "@forwardflow/components/Signup";

const Signup = () => {
  return (
    <>
      <SignupComponent />
    </>
  );
};
export default Signup;
